import React, { useState } from "react"

import {
  Box,
  Button,
  Flex,
  HeadingFive,
  HeadingTwo,
  Input,
  Textarea,
  Stack,
  TextSM,
} from "datastory-shared/ui"

const validateEmail = email => {
  const re =
    //eslint-disable-next-line
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
  return re.test(email)
}

export const DatastoryAcademySignup = () => {
  const [email, setEmail] = useState("")
  const [name, setName] = useState("")
  const [school, setSchool] = useState("")
  const [classYear, setClassYear] = useState("")
  const [interest, setInterest] = useState("")
  const [messageVariant, setMessageVariant] = useState("info")
  const [nameError, setNameError] = useState("")
  const [schoolError, setSchoolError] = useState("")
  const [classYearError, setClassYearError] = useState("")
  const [interestError, setInterestError] = useState("")
  const [emailError, setEmailError] = useState("")

  const messages = {
    success: "Tack för din anmälan!",
    memberExists: "Du är redan anmäld",
    error: "Något gick fel",
    invalidEmail: "Ogiltig e-postadress",
    missingName: "Vänligen ange ditt namn",
    missingSchool: "Vänligen ange din skola",
    missingClassYear: "Vänligen ange årskurs",
    missingInterest: "Vänligen motivera ditt intresse för kursen",
  }

  const handleSubmit = e => {
    e.preventDefault()

    if (!validateEmail(email)) {
      setEmailError(messages.invalidEmail)
      setMessageVariant("info")
    } else {
      setEmailError("")
    }

    if (name === "") {
      setNameError(messages.missingName)

      setMessageVariant("info")
    } else {
      setNameError("")
    }

    if (!school) {
      setSchoolError(messages.missingSchool)

      setMessageVariant("info")
    } else {
      setSchoolError("")
    }

    if (!classYear) {
      setClassYearError(messages.missingClassYear)

      setMessageVariant("info")
    } else {
      setClassYearError("")
    }

    if (!interest) {
      setInterestError(messages.missingInterest)

      setMessageVariant("info")
    }

    if (!validateEmail(email) || !name || !school || !classYear || !interest) {
      return
    }

    fetch("/api/newsletter", {
      method: "post",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        email_address: email,
        merge_fields: {
          FNAME: name.split(" ")[0],
          LNAME: name.split(" ")[1],
          SCHOOL: school,
          CLASS_YEAR: classYear,
          INTEREST: interest,
        },
        status: "subscribed",
        tags: ["Datastory Academy"],
        language: "en",
      }),
    })
      .then(response => response.json())
      .then(({ message }) => {
        setMessageVariant(message !== "error" ? "success" : "warning")
      })
      .catch(() => {
        setMessageVariant("warning")
      })
  }

  const handleValidateEmail = e => {
    setEmail(e.target.value)
    setEmailError("")
  }

  const handleValidateName = e => {
    setName(e.target.value)
    setNameError("")
  }

  const handleValidateSchool = e => {
    setSchool(e.target.value)
    setSchoolError("")
  }

  const handleValidateClassYear = e => {
    setClassYear(e.target.value)
    setClassYearError("")
  }

  const handleValidateInterest = e => {
    setInterest(e.target.value)
    setInterestError("")
  }

  return (
    <Box
      as="form"
      onSubmit={handleSubmit}
      px={5}
      py={5}
      mt={5}
      background="white"
      borderRadius={8}
      border="2px"
      borderColor="gray.100"
      h={messageVariant == "success" ? "100%" : "auto"}
    >
      {messageVariant == "success" ? (
        <Stack
          spacing="10"
          textAlign="center"
          pt={5}
          minH="100%"
          justifyContent="center"
        >
          <HeadingTwo>Tack för din anmälan!</HeadingTwo>
          <Box fontSize={"3rem"}>👏</Box>
        </Stack>
      ) : (
        <Stack spacing="5">
          <HeadingFive>
            Anmäl ditt intresse för Datastory Academy, så håller vi dig
            informerad om datum för våra kommande kurser! ✍️
          </HeadingFive>
          <Box>
            <TextSM>Namn*</TextSM>
            <TextSM color="red.500">{nameError}</TextSM>
            <Input
              onChange={e => handleValidateName(e)}
              minWidth="10rem"
              placeholder={""}
            />
          </Box>
          <Box>
            <TextSM>Mejladress*</TextSM>
            <TextSM color="red.500">{emailError}</TextSM>
            <Input minWidth="10rem" onChange={e => handleValidateEmail(e)} />
          </Box>
          <Box>
            <TextSM>Skola*</TextSM>
            <TextSM color="red.500">{schoolError}</TextSM>
            <Input onChange={e => handleValidateSchool(e)} minWidth="10rem" />
          </Box>
          <Box>
            <TextSM>Årskurs*</TextSM>
            <TextSM color="red.500">{classYearError}</TextSM>
            <Input
              onChange={e => handleValidateClassYear(e)}
              minWidth="10rem"
            />
          </Box>
          <Box>
            <TextSM>Beskriv kort varför du vill delta*</TextSM>
            <TextSM color="red.500">{interestError}</TextSM>
            <Textarea
              onChange={e => handleValidateInterest(e)}
              minWidth="10rem"
            />
          </Box>
          <Flex
            alignItems={"center"}
            alignContent={"center"}
            justifyContent={"space-between"}
          >
            <Button type="submit" colorScheme="primary" maxWidth={"200px"}>
              Skicka intresseanmälan
            </Button>
          </Flex>
        </Stack>
      )}
    </Box>
  )
}
